import React from "react"
//https://github.com/lipis/flag-icon-css/blob/master/flags/4x3/at.svg?short_path=e63fb2e
export default function AustrianFlag({ style, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
      viewBox="0 0 640 480"
    >
      <g fillRule="evenodd">
        <path fill="#fff" d="M640 480H0V0h640z"></path>
        <path fill="#ed2939" d="M640 480H0V320h640zm0-319.9H0V.1h640z"></path>
      </g>
    </svg>
  )
}
